import { useEffect, useState } from 'react';
import { get } from '../../rest/api';
import { RubroListData } from '../../model/RubroListData';
import { rubroListDataMapping } from '../../rest/rubroListDataMapping';
import { URL_API_RUBRO_LIST } from '../../constants/urls';
import { RubroData } from '../../model/RubroData';

export const useRubros = () => {
  const [rubros, setRubros] = useState<RubroListData | undefined>();

  const handleResponse = (response: RubroData[] | undefined) => {
    if (response?.length && response.length > 0) setRubros(rubroListDataMapping(response));
  };

  useEffect(() => {
    get(URL_API_RUBRO_LIST, handleResponse);
  }, []);

  return rubros;
};
